import { Navigate, Route, Routes } from "react-router-dom";
import { AdminApp } from "./admin/AdminApp";
import { getToken } from "./api";
import { CaseDetail } from "./public/CaseDetail";
import { CaseHome } from "./public/CaseHome";

export function App() {
  return (
    <Routes>
      <Route path="/" element={<CaseHome />} />
      <Route path="/cases/:slug" element={<CaseDetail />} />
      <Route path="/admin/*" element={getToken() ? <AdminApp /> : <AdminApp initialLogin />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

